import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31707dd4")

_pushScopeId("data-v-31707dd4")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 予約登録・変更 ")
const _hoisted_2 = { class: "calendar-day-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_doctor_tag = _resolveComponent("doctor-tag")
  const _component_calendar = _resolveComponent("calendar")
  const _component_appointment_type_selector = _resolveComponent("appointment-type-selector")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_calendar, {
        disableAfterToday: false,
        onAdd: _ctx.onAdd
      }, _createSlots({ _: 2 }, [
        _renderList(_ctx.appointmentList, (day, dayIndex) => {
          return {
            name: `day_${day.day}`,
            fn: _withId(() => [
              _createVNode("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(day.accountList, (account, accountIndex) => {
                  return (_openBlock(), _createBlock(_component_doctor_tag, {
                    class: "calendar-day-content-tag",
                    key: 'appointment'+dayIndex+'-'+accountIndex,
                    doctorName: account.accountName,
                    appointmentList: account.appointmentList,
                    onClick: ($event: any) => (_ctx.onSelectAppointment(day.day, account.accountId, account.appointmentList.length))
                  }, null, 8, ["doctorName", "appointmentList", "onClick"]))
                }), 128))
              ])
            ])
          }
        })
      ]), 1032, ["onAdd"]),
      _createVNode(_component_appointment_type_selector, {
        ref: "selectorRef",
        onTemporaryPatient: _ctx.onTemporaryPatient,
        onSelectPatient: _ctx.onSelectPatient
      }, null, 8, ["onTemporaryPatient", "onSelectPatient"])
    ]),
    _: 1
  }))
})